import * as stylex from "@stylexjs/stylex";
import { Fragment, cloneElement, isValidElement, useId, type ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";
const styles = {
  field: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "xsuxsxl",
    k7Eaqz: "xeuugli",
    $$css: true
  }
};
export interface FieldProps {
  label: ReactNode;
  htmlFor?: string;
  /** Only when the field is not obvious from its label. */
  hint?: ReactNode;
  error?: string;
  xstyle?: stylex.StyleXStyles;
  children: ReactNode;
}

// Label + control + optional hint or error. `htmlFor` is optional so a bare
// `<label>` can wrap its control the implicit way when there is one control.
// The hint or error describes the control: a single child element gets
// `aria-describedby` pointing at it, added to any description it already has.
export default function Field({
  label,
  htmlFor,
  hint,
  error,
  xstyle,
  children
}: FieldProps) {
  const messageId = useId();
  const describedBy = error || hint ? messageId : undefined;
  const control = describedBy && isValidElement<{
    "aria-describedby"?: string;
  }>(children) && children.type !== Fragment ? cloneElement(children, {
    "aria-describedby": [children.props["aria-describedby"], describedBy].filter(Boolean).join(" ")
  }) : children;
  // The hint and error sit outside the label so they are not part of the
  // control's accessible name.
  return <div {...stylex.props(styles.field, xstyle)}>
      <label htmlFor={htmlFor} className="x78zum5 xdt5ytf xsuxsxl xeuugli">
        <span className="x7x6yu3 xk50ysn x1e3avs9">{label}</span>
        {control}
      </label>
      {error ? <p id={messageId} role="alert" className="x1ghz6dp x7x6yu3 x1nif09i">
          {error}
        </p> : hint && <p id={messageId} className="x1ghz6dp x7x6yu3 x1i6qc9y">
            {hint}
          </p>}
    </div>;
}